import { createSlice } from "@reduxjs/toolkit";
import {
  getSchedulingNotificationAction,
  getSchedulingNotificationCountAction,
} from "./action";
import { notificationReducer } from "./reducer";
import { initialState } from "./initialState";
import { NotificationType } from "./notificationTypes";

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: notificationReducer,
  extraReducers: (builder) => {
    builder
      .addCase(
        getSchedulingNotificationAction.pending,
        (state: NotificationType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getSchedulingNotificationAction.fulfilled,
        (state: NotificationType, { payload }) => {
          const { result = {}, message, status_code, success, count } = payload;
          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }
          return {
            ...state,
            fetching: false,
            scheduleNotificationList: result,
            scheduleNotificationListCount: count,
          };
        }
      )
      .addCase(
        getSchedulingNotificationAction.rejected,
        (state: NotificationType, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      )
      .addCase(
        getSchedulingNotificationCountAction.pending,
        (state: NotificationType) => ({
          ...state,
          fetching: true,
        })
      )
      .addCase(
        getSchedulingNotificationCountAction.fulfilled,
        (state: NotificationType, { payload }) => {
          const {
            notification_count,
            message,
            status_code,
            success,
            attendence,
          } = payload;
          if (success === 0) {
            return {
              ...state,
              fetching: false,
              error: message,
              success: 0,
              statusCode: status_code,
            };
          }
          return {
            ...state,
            fetching: false,
            scheduleNotificationCount: notification_count,
            attendence,
          };
        }
      )
      .addCase(
        getSchedulingNotificationCountAction.rejected,
        (state: NotificationType, { error }) => ({
          ...state,
          fetching: false,
          error: error?.message,
          success: 0,
        })
      );
  },
});

export const {
  resetNotificationError,
  resetNotificationSuccess,
  resetScheduleNotificationCount,
  resetScheduleNotificationList,
  resetNotificationStatusCode,
  resetScheduleNotificationListCount,
  setNotificationCount,
  resetNotificationCount,
} = notificationSlice.actions;
